import {
  ChangeEvent, KeyboardEvent, useCallback, useContext, useEffect, useRef
} from "react";

import { ISearchBox } from "@fluentui/react/lib/SearchBox";
import { IUseAutoCompleteProps } from "./IUseAutoCompleteProps";
import { SearchContext } from "../SearchContext";

export function useAutoComplete(): IUseAutoCompleteProps {
  const {
    setIsCalloutFocused,
    setIsCallOutVisible,
    focusZoneRef,
    onChange,
    searchRef,
    setFocusBackToSearchbox,
    focusBackToSearchbox
  } = useContext(SearchContext);

  const searchBoxRef = useRef<ISearchBox>(null);

  useEffect(() => {
    if (focusBackToSearchbox) {
      searchBoxRef.current.focus();
    }
    setFocusBackToSearchbox(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchRef, focusBackToSearchbox]);

  const onKeyDown = useCallback(
    (event: KeyboardEvent<HTMLInputElement>) => {
      if (event.key === `ArrowDown`) {
        setIsCalloutFocused(true);
        setIsCallOutVisible(true);
        setFocusBackToSearchbox(false);
        focusZoneRef.current?.focus();
        event.preventDefault();
      }
    },
    [focusZoneRef, setFocusBackToSearchbox, setIsCallOutVisible, setIsCalloutFocused]
  );

  const onFocusDiv = useCallback(() => {
    setIsCalloutFocused(false);
    setIsCallOutVisible(true);
  }, [setIsCallOutVisible, setIsCalloutFocused]);

  const onFocusSearchBox = useCallback(() => {
    setIsCallOutVisible(true);
  }, [setIsCallOutVisible]);

  const onChangeInternal = useCallback(
    (event?: ChangeEvent<HTMLInputElement>, newValue?: string) => {
      setIsCallOutVisible(true);
      onChange(event, newValue);
    },
    [onChange, setIsCallOutVisible]
  );

  return {
    onChange: onChangeInternal,
    onFocusDiv,
    onFocusSearchBox,
    onKeyDown,
    searchBoxRef
  };
}
